import styled from 'styled-components';
import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover';
import { AncestorIdData, AncestorNameData, FolderId } from 'modules/domains/foldering';
import { ChevronRightSmall } from 'ui/icons/navigation/ChevronRightSmall';
import { body2, spacing } from 'ui/theme';
import { SimpleBreadcrumb } from './SimpleBreadcrumb';

const StyledPopoverContent = styled(PopoverContent)`
  max-width: 80vw;
  width: 100%;
`;

const BreadcrumbContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.half};
`;

export const StyledContainer = styled.div`
  align-items: center;
  ${body2}
`;

type FolderBreadcrumbPopoverProps = {
  /** folders to display in the toggletip */
  contents: (AncestorIdData & AncestorNameData)[];
  /** id of folder item */
  id: FolderId;
  /** index in ancestors array */
  index: number;
};

export const FolderBreadcrumbPopover = ({
  contents,
  index,
  id,
  ...props
}: FolderBreadcrumbPopoverProps) => (
  <StyledContainer data-test={`folder-breadcrumb-item-${index}`} key={id.toString()} {...props}>
    <ChevronRightSmall />
    <Popover>
      <StyledPopoverContent>
        <BreadcrumbContainer>
          {contents.map((breadcrumb, idx) => (
            <SimpleBreadcrumb
              data={breadcrumb}
              key={breadcrumb.id}
              isCurrentFolder={false}
              isMini
              isRoot={idx === 0}
              nestIndex={idx + 1}
            />
          ))}
        </BreadcrumbContainer>
      </StyledPopoverContent>
      <PopoverTrigger>...</PopoverTrigger>
    </Popover>
  </StyledContainer>
);
